// extracted by mini-css-extract-plugin
export default {"qr-image":"_1qKdujQh","qrImage":"_1qKdujQh","headingInstruction":"KbSVnI1I"};